var module = angular.module('akimboApp.directives', []);

module.directive('fallbackSrc', [function () {
  return {
    link: function postLink(scope, el, attrs) {
      el.bind('error', function() {
        angular.element(this).attr("src", attrs.fallbackSrc);
      });
    }
  };
}]);

module.directive('fallbackHref', [function () {
  return {
    link: function postLink(scope, el, attrs) {
      el.bind('error', function() {
        angular.element(this).attr("href", attrs.fallbackHref);
      });
    }
  };
}]);

module.directive('autoTabTo', [function () {
  return {
    restrict: 'A',
    link: function(scope, el, attrs) {
      el.bind('keyup', function(e) {
        if(this.value.length === this.maxLength){
          var element = document.getElementById(attrs.autoTabTo);
          if(element){
            element.focus();
          }
        }
      });
    }
  };
}]);

module.directive('validatePoBox', function (){
  return {
    require: 'ngModel',
    link: function(scope, elem, attrs, ctrl) {
      ctrl.$parsers.unshift(function(value) {
        var valid;
        // Old pattern
        //var pattern = /^ *(((box|bin)[-. \/\\]?\d+)|(.*p[ \.]? ?(o|0)[-. \/\\]? *-?((box|bin)|b|(num)?\d+))|(p(ost)? *(o(ff(ice)?)?)? *((box|bin)|b)? *\d+)|(p *-?\/?(o)? *-?box)|post office box|((box|bin)|b) *(number|num)? *\d+|(num|number) *\d+)/i;
        var pattern = /\bbox(?:\b$|([\s|\-]+)?[0-9]+)|(p[\-\.\s]?o.?[\-\s]?|post office\s)b(\.|ox)?/igm;
        if(value.match(pattern) && value.toLowerCase().indexOf("pobl") == -1) {
          valid = false;
        } else {
          valid = true;
        }
        ctrl.$setValidity(attrs.name, valid);
        return valid ? value : undefined;
      });
    }
  };
});

module.directive('validatePin', ['ValidateServicePin', function (ValidateServicePin){
  return {
    require: 'ngModel',
    link: function(scope, elem, attrs, ctrl) {
      ctrl.$parsers.unshift(function(value) {
        var valid;
        if(ValidateServicePin.checkPin(value) != 'valid'){
          valid = false;
        }
        else if(ValidateServicePin.checkPin(value) == ' Please select an uncommon PIN.') {
          valid = false;
        }
        else {
          valid = true;
        }
        ctrl.$setValidity(attrs.name, valid);
        return valid ? value : undefined;
      });
    }
  };
}]);


module.directive('validatePassword', ['ValidateService', function (ValidateService){
  return {
    require: 'ngModel',
    link: function(scope, elem, attrs, ctrl) {
      ctrl.$parsers.unshift(function(value) {
        var valid;
        if(ValidateService.checkPwd(value) != 'valid'){
          valid = false;
        } else {
          valid = true;
        }
        ctrl.$setValidity(attrs.name, valid);
        return valid ? value : undefined;
      });
    }
  };
}]);

// confirm password, used for all confirm password inputs where formData is parent object
module.directive('confirmPassword', ['ValidateService', function (ValidateService){
  return {
    require: 'ngModel',
    link: function(scope, elem, attrs, ctrl) {
      ctrl.$parsers.unshift(function(value) {
        var valid;
        var compareWith;

        if (scope.$parent.formData) {
          compareWith = scope.$parent.formData.Password;
        } else if (scope.signupLoginForm) {
          compareWith = scope.signupLoginForm.Password.$viewValue;
        }

        if(ValidateService.checkPwd(value) === 'valid' && compareWith === value){
          valid = true;
        } else {
          valid = false;
        }
        ctrl.$setValidity(attrs.name, valid);
        return valid ? value : undefined;
      });
    }
  };
}]);

module.directive('cardImage', [function () {
  return {
    restrict: 'E',
    templateUrl: 'app/views/member/shared/card-image.html',
    scope: {
      designId: '=',
      hasMobileImage: '=?hasMobileImage'
    },
    transclude: true,
    controller: function (File, $scope, $rootScope) {
      if (!$rootScope.designIDChecked) {
        $rootScope.designIDChecked = {};
      }

      if ($rootScope.designIDChecked[$scope.designId] !== undefined) {
        $scope.hasMobileImage = $rootScope.designIDChecked[$scope.designId];
        return;
      }

      File.cardImageExists($scope.designId).then(function(exists) {
        $rootScope.designIDChecked[$scope.designId] = exists;
        $scope.hasMobileImage = exists;
      });
    },
  };
}]);

module.directive('cardImageSmall', [function () {
  return {
    restrict: 'E',
    templateUrl: 'app/views/member/shared/card-image-small.html',
    scope: {
      designId: '=',
      hasMobileImage: '=?hasMobileImage'
    },
    transclude: true,
    controller: function (File, $scope) {
      File.cardImageExists($scope.designId).then(function(exists) {
        $scope.hasMobileImage = exists;
      });
    },
  };
}]);


module.directive('textAlertsCheckbox', [function () {
  return {
    restrict: 'E',
    templateUrl: 'app/views/member/shared/checkboxes.html',
    scope: {
      formData: '=',
    }
  };
}]);


module.directive('creditCardType', function(){
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl){
      ctrl.$parsers.unshift(function(value){
        var cctype =
          (/^5[1-5]/.test(value)) ? 'MasterCard'
          : (/^4/.test(value)) ? 'Visa'
          : (/^3[47]/.test(value)) ? 'Amex'
          : (/^6011|65|64[4-9]|622(1(2[6-9]|[3-9]\d)|[2-8]\d{2}|9([01]\d|2[0-5]))/.test(value)) ? 'Discover'
          : undefined;

        scope.$parent.formData.cctype = cctype;
        scope.$parent.formData.cvvLength = cctype == 'Amex' ? 4 : 3;
        ctrl.$setValidity('invalid',!!scope.$parent.formData.cctype);
        return value;
      });
    }
  };
});


module.directive('cvvLength', function(){
  return {
    require: 'ngModel',
    link: function(scope, elm, attrs, ctrl){
      ctrl.$parsers.unshift(function(value){
        var cvvLength = scope.$parent.formData.cvvLength;
        ctrl.$setValidity('invalid', (value.length === cvvLength));
        return value;
      });
    }
  };
});


/*
 * matchElem directive
 * matches [elemname]1 to [elemname]
 * in formData scope
 */
module.directive('matchElem', function(){
  return {
    require: 'ngModel',
    link: function(scope, elem, attrs, ctrl){
      ctrl.$parsers.unshift(function(value) {
        var valid;
        var matchElem = attrs.name.slice(0, -1);
        if(scope.$parent.formData[matchElem] === value){
          valid = true;
        } else {
          valid = false;
        }
        ctrl.$setValidity(attrs.name, valid);
        return valid ? value : undefined;
      });
    }
  };
});


module.directive('expInputHelper', function(){
  return {
    require: 'ngModel',
    link: function(scope, el, attrs, ctrl) {
      el.bind('keyup', function(e) {
        if(this.value.length == 1 && this.value > 1){
          this.value = 0 + this.value;
        }
      });
      ctrl.$parsers.unshift(function(value){
        if(value.length == 5){
          ctrl.$setValidity(attrs.name, true);
          return value;
        } else if(value.length == 7 && value[3] == '2' && value[4] === '0'){
          ctrl.$setValidity(attrs.name, true);
          return value;
        } else {
          ctrl.$setValidity(attrs.name, false);
          return value;
        }
      });
    }
  };
});


// Click anywhere service, used in expanded feed.
module.factory('clickAnywhereButHereService', function($document){
  var tracker = [];

  return function($scope, expr) {
    var i, t, len;
    for(i = 0, len = tracker.length; i < len; i++) {
      t = tracker[i];
      if(t.expr === expr && t.scope === $scope) {
        return t;
      }
    }
    var handler = function() {
      $scope.$apply(expr);
    };

    $document.on('click', handler);

    // IMPORTANT! Tear down this event handler when the scope is destroyed.
    $scope.$on('$destroy', function(){
      $document.off('click', handler);
    });

    t = { scope: $scope, expr: expr };
    tracker.push(t);
    return t;
  };
});

// Directive for clickanywhere service, listens to clicks, and calls clickanywhere service on clicks with attr clicked.
module.directive('clickAnywhereButHere', function($document, clickAnywhereButHereService){
  return {
    restrict: 'A',
    link: function(scope, elem, attr, ctrl) {
      var handler = function(e) {
        e.stopPropagation();
      };
      elem.on('click', handler);

      scope.$on('$destroy', function(){
        elem.off('click', handler);
      });

      clickAnywhereButHereService(scope, attr.clickAnywhereButHere);
    }
  };
});

// Auto fill form fix
module.directive('formAutoFillFix', function(){
  return function(scope, elem, attrs) {
    // Fixes Chrome bug: https://groups.google.com/forum/#!topic/angular/6NlucSskQjY
    elem.prop('method', 'POST');

    // Fix autofill issues where Angular doesn't know about autofilled inputs
    if(attrs.ngSubmit) {
      setTimeout(function() {
        elem.unbind('submit').bind('submit', function(e) {
          e.preventDefault();
          // Trigger change event to update input fields
          elem.find('input').triggerHandler('change');
          scope.$apply(attrs.ngSubmit);
        });
      }, 0);
    }
  };
});


// Calendar picker
module.directive('calendarModal', ['recurringTransferService', 'FREQUENCY_OPTIONS', function(recurringTransferService, FREQUENCY_OPTIONS){
  return {
    restrict: 'E',
    scope: true,
    replace: true,
    transclude: true,
    templateUrl: 'app/views/member/shared/overlay/calendar.html',
    link: function(scope, element, attrs){
      // Datepicker
      var weekDate = moment().weekday();
      var monthDate = moment().date();
      var defaultToday = attrs.defaultToday;

      scope.datePicker           = {};
      scope.datePicker.day1      = {};
      scope.datePicker.day2      = {};
      scope.datePicker.dateSelect= {};
      scope.dayOptions           = [];
      scope.dateOptions          = [];
      scope.frequencyOptions     = FREQUENCY_OPTIONS;

      // Watch scheduleText for updates
      // Set parent formdata with the updates
      scope.$watch('scheduleText', function(){
        scope.$parent.$parent.formData.datePicker = scope.datePicker;
        scope.$parent.$parent.formData.scheduleText = scope.scheduleText;
        scope.$parent.$parent.formData.dateOptions = scope.dateOptions;
      });

      // Called on frequency selector change event
      scope.changeFreq = function(){
        var freqOptions = recurringTransferService.setDayOptions(scope.datePicker.frequency.key);
        scope.dayOptions = freqOptions.dayOptions;

        if(defaultToday){
          if(scope.datePicker.frequency.key == 'E' || scope.datePicker.frequency.key == 'F'){
            scope.datePicker.day1 = scope.dayOptions[weekDate];
          } else {
            scope.datePicker.day1 = scope.dayOptions[monthDate - 1];
          }
        }

        scope.datePicker.day2 = freqOptions.day2;
        var dateOptions = recurringTransferService.setDateOptions(scope.datePicker, defaultToday);
        scope.dateOptions = dateOptions;
        scope.datePicker.dateSelect = dateOptions[0];

        scope.scheduleText = recurringTransferService.updateText(scope.datePicker);
      };

      // Called on day1 selector change event
      scope.changeDay1 = function(){
        var dateOptions = recurringTransferService.setDateOptions(scope.datePicker, defaultToday);
        scope.dateOptions = dateOptions;
        scope.datePicker.dateSelect = dateOptions[0];

        scope.scheduleText = recurringTransferService.updateText(scope.datePicker);
      };

      // Called on day2 selector change event
      scope.changeDay2 = function(){
        var dateOptions = recurringTransferService.setDateOptions(scope.datePicker, defaultToday);
        scope.dateOptions = dateOptions;
        scope.datePicker.dateSelect = dateOptions[0];

        scope.scheduleText = recurringTransferService.updateText(scope.datePicker);
      };

      // Called on date selector change event
      scope.changeDate = function(){
        if(scope.datePicker.dateSelect == 'Today'){

        } else {
          scope.scheduleText = recurringTransferService.updateText(scope.datePicker);
        }
      };

      // set defaults for today
      if(defaultToday && scope.$parent.$parent.formData.scheduleText === undefined){
        scope.datePicker.frequency = {
          key: 'E',
          label: 'Every Week'
        };
        scope.changeFreq();
        scope.changeDay1();
      } else if(scope.$parent.$parent.formData.scheduleText) {
        // prevent the preset options from being lost on state change
        scope.datePicker = scope.$parent.$parent.formData.datePicker;
        scope.scheduleText = scope.$parent.$parent.formData.scheduleText;
        scope.dateOptions = scope.$parent.$parent.formData.dateOptions;
      }

    }
  };
}]);

// appends confirmation html to body
module.directive('confirmationOverlay', ['$compile', '$http', function($compile, $http){
  return {
    restrict: 'A',
    scope: {
      confirmationOverlayMessage: '@'
    },
    link: function(scope, elem, attrs){
      var template;
      $http.get('app/views/member/shared/confirmation-modal.html', {cache: true}).then(function(html){
        template = html.data;
      });

      scope.brand = scope.$parent.brand;

      scope.removeConfirmation = function(){
        // remove the element
        angular.element(document.querySelector('#confirmationOverlay')).remove();
      };

      elem.on('click', function(e){
        e.preventDefault();
        scope.outBoundLink = attrs.href;
        var modal = $compile(template)(scope);
        angular.element(document.body).append(modal);
      });
    }
  };
}]);

// account selector modal
module.directive('accountSelector', ['$compile', '$http', 'accountService', '$state', function($compile, $http, accountService, $state){
  return {
    restrict: 'E',
    scope: true,
    replace: true,
    transclude: true,
    templateUrl: 'app/views/member/shared/accountSelector.html',
    link: function(scope, elem, attrs){
      scope.accounts = accountService.getAccounts();

      scope.closeAccountSelector = function(){
        scope.$parent.$parent.openAccountSelector = false;
      };

    }
  };
}]);

// when scroll directive update get feed
module.directive('whenScrolled', function($window, $timeout){
  return {
    scope: {
      callback: '&',
      disabled: '='
    },
    restrict: 'EA',
    link: function(scope, elem, attr){
      var win = angular.element($window);

      var onScroll = function(e){

        var windowHeight = win[0].innerHeight;
        var elementBottom = elem[0].offsetTop + elem[0].offsetHeight;
        var windowBottom = windowHeight + (win[0].scrollY || win[0].pageYOffset);
        var remaining = elementBottom - windowBottom;
        var shouldGetMore = (remaining - parseInt(scope.distance || 0, 10) <= 0);

        if(shouldGetMore){
          $timeout(scope.callback);
        }

      };

      // remove event handler on destroy
      scope.$on('$destroy', function(){
        win.unbind('scroll', onScroll);
      });

      win.bind('scroll', onScroll);

      $timeout(onScroll);

    }
  };
});
// when scroll directive update get feed
module.directive('whenPaginatedScrolled', function($window, $timeout){
  return {
    scope: {
      callback: '&',
      disabled: '='
    },
    restrict: 'EA',
    link: function(scope, elem, attr){
      var win = angular.element($window);

      var onScroll = function(e){
        var height = elem[0].scrollHeight;
        var delta =   elem[0].scrollTop + elem[0].offsetHeight - height;

        var shouldGetMore = delta >=  -200;

        if(shouldGetMore){
          $timeout(scope.callback);
        }

      };

      //remove event handler on destroy
      scope.$on('$destroy', function(){

        elem.unbind('scroll', onScroll);

      });

      elem.bind('scroll', onScroll);

      $timeout(onScroll);

    }
  };
});


// add position fix to widgets when CH scrolls down page
module.directive('scrollBarDisplay', function($window, $timeout){
  return {
    link: function(scope, elem, attr){

        if(elem[0].children[0].className === 'view-all-container'){
           //hide scroll bar
           elem.parent().parent().parent().addClass('scrollBarDisplay');
        } else {
          elem.parent().parent().parent().removeClass('scrollBarDisplay');
        }
     }
  };
});

// add position fix to widgets when CH scrolls down page
module.directive('fixWidgetScroll', function($window, $timeout){
  return {
    link: function(scope, elem, attr){
      var win = angular.element($window);
      var topOffset = 280;
      var oldScrollValue = 0;

      var onScroll = function(e){
        var elemHeight = elem[0].offsetHeight;
        var windowHeight = win[0].innerHeight;
        var currentScroll = win[0].scrollY;

        // check if we need a ping pong implementation
        if(elemHeight + topOffset < windowHeight){

          if(currentScroll > topOffset){
            elem.addClass('fixWidgetViewTop');
            elem.removeClass('defaultWidgetView');
          } else {
            elem.removeClass('fixWidgetViewTop');
            elem.addClass('defaultWidgetView');
          }

          return;
        }

        if(currentScroll + windowHeight >= topOffset + elemHeight + 60){
          elem.addClass('fixWidgetViewBottom');
          elem.removeClass('defaultWidgetView');
        } else {
          elem.removeClass('fixWidgetViewBottom');
          elem.addClass('defaultWidgetView');
        }

        // set old scroll value
        oldScrollValue = currentScroll;

      };

      scope.$on('$destroy', function(){
        win.unbind('scroll', onScroll);
      });


      // prevent scroll effect on mobile
      if($window.innerWidth > 768){

        // add event handler
        win.bind('scroll', onScroll);

        // get initial scroll position
        $timeout(onScroll);

      }

    }
  };
});

// Allow only numbers in input
module.directive('akInputOnlyNumbers', function () {
  function link(scope, element, attr, ngModelCtrl) {
    function removeNonNumbers(value) {
      if (value) {
        var removedNumbers = value.replace(/[^0-9]/g, '');

        if (removedNumbers !== value) {
          ngModelCtrl.$setViewValue(removedNumbers);
          ngModelCtrl.$render();
        }
        return removedNumbers;
      }
      return undefined;
    }

    ngModelCtrl.$parsers.push(removeNonNumbers);
  }

  return {
    require: 'ngModel',
    link: link
  };
});

// Allow only numbers, spaces, and + in phone input
module.directive('akInputOnlyPhone', function () {
  function link(scope, element, attr, ngModelCtrl) {
    function removeNonNumbers(value) {
      if (value) {
        var removedNumbers = value.replace(/[^0-9+\s]/g, '');

        if (removedNumbers !== value) {
          ngModelCtrl.$setViewValue(removedNumbers);
          ngModelCtrl.$render();
        }
        return removedNumbers;
      }
      return undefined;
    }

    ngModelCtrl.$parsers.push(removeNonNumbers);
  }

  return {
    require: 'ngModel',
    link: link
  };
});

// Add country code, parenthesis, and dashes to foreign phone numbers
module.directive('akFormatForeignPhoneNumber', function() {
  function link(scope, element, attrs) {
    var number;

    function formatNumber() {
      var preFormattedNumber;
      var formattedNumber;

      if ( number ) {
        // Strip all characters from the input except digits
        preFormattedNumber = number.toString().replace(/\D/g,'');

        // Based upon the length of the string, we add formatting as necessary
        var size = preFormattedNumber.length;

        if (size === 0) {
          formattedNumber = preFormattedNumber;
        } else if (size < 4) {
          formattedNumber = '(' + preFormattedNumber;
        } else if (size < 7) {
          formattedNumber = '(' + preFormattedNumber.substring(0,3) + ') ' + preFormattedNumber.substring(3,6);
        } else if (size < 11) {
          formattedNumber = '(' + preFormattedNumber.substring(0,3) + ') ' + preFormattedNumber.substring(3,6) + ' - ' + preFormattedNumber.substring(6,10);
        } else {
          formattedNumber = '+' + preFormattedNumber.substring(0,1) + ' (' + preFormattedNumber.substring(1,4) + ') ' + preFormattedNumber.substring(4,7) + ' - ' + preFormattedNumber.substring(7,11);
        }

      } else {
        formattedNumber = '';
      }

      // Output the result in the html
      element.text(formattedNumber);
    }

    // Make sure you set ng-model-options="{ allowInvalid: true }"
    // in the source input for this watch to work as the user types
    scope.$watch(attrs.akFormatForeignPhoneNumber, function(value) {
      number = value;
      formatNumber();
    });
  }

  return {
    link: link
  };
});

// Add parenthesis and dashes to phone numbers
module.directive('akFormatPhoneNumber', function() {
  function link(scope, element, attrs) {
    var number;

    function formatNumber() {
      var preFormattedNumber;
      var formattedNumber;

      if ( number ) {
        // Strip all characters from the input except digits
        preFormattedNumber = number.toString().replace(/\D/g,'');

        // Trim the remaining input to ten characters, to preserve phone number format
        preFormattedNumber = preFormattedNumber.substring(0,10);

        // Based upon the length of the string, we add formatting as necessary
        var size = preFormattedNumber.length;

        if (size === 0) {
          formattedNumber = preFormattedNumber;
        } else if (size < 4) {
          formattedNumber = '(' + preFormattedNumber;
        } else if (size < 7) {
          formattedNumber = '(' + preFormattedNumber.substring(0,3) + ') ' + preFormattedNumber.substring(3,6);
        }else{
          formattedNumber = '(' + preFormattedNumber.substring(0,3) + ') ' + preFormattedNumber.substring(3,6) + ' - ' + preFormattedNumber.substring(6,10);
        }

      } else {
        formattedNumber = '';
      }

      // Output the result in the html
      element.text(formattedNumber);
    }

    // Make sure you set ng-model-options="{ allowInvalid: true }"
    // in the source input for this watch to work as the user types
    scope.$watch(attrs.akFormatPhoneNumber, function(value) {
      number = value;
      formatNumber();
    });
  }

  return {
    link: link
  };
});

module.directive('akWidget', function() {
  return {
    restrict: 'E',
    scope: {
      widget: '=',
    },
    templateUrl: 'app/views/member/shared/widget.html',
    link: function(scope, element, attrs) {
      scope.brand = scope.$parent.brand;

      scope.navigate = function(widget){
        return scope.$parent.$parent.navigate(widget);
      };

      scope.getStateLink = function(widget){
        return scope.$parent.$parent.getStateLink(widget);
      };

      // Define styling classes for widget
      if (typeof scope.widget.color !== 'undefined') {
        switch(scope.widget.color) {
          case 'green':
            scope.isAltBtn = true;
            break;
          case 'blue':
            scope.isAlt2Btn = true;
            break;
          case 'notification':
            scope.isFullWidthBtn = true;
            break;
        }
      }
    }
  };
});

